var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 8.66634C10.147 8.15137 9.34786 7.80694 8.50201 7.66143C7.65615 7.51591 6.78783 7.57348 5.96858 7.82939C5.14934 8.0853 4.40264 8.53223 3.79001 9.13334C3.17739 9.73445 2.71637 10.4725 2.44496 11.2868C2.17355 12.101 2.09951 12.9681 2.22894 13.8166C2.35838 14.665 2.68759 15.4706 3.18943 16.1669C3.69128 16.8631 4.3514 17.4302 5.11539 17.8213C5.87938 18.2124 6.72538 18.4163 7.58366 18.4163C10.5747 18.4163 11.3753 16.2497 13.0003 12.9997C14.6253 9.74968 15.4259 7.58301 18.417 7.58301C19.2753 7.58301 20.1213 7.78696 20.8853 8.17807C21.6493 8.56917 22.3094 9.13622 22.8112 9.83249C23.3131 10.5288 23.6423 11.3343 23.7717 12.1828C23.9011 13.0313 23.8271 13.8983 23.5557 14.7126C23.2843 15.5268 22.8233 16.2649 22.2106 16.866C21.598 17.4671 20.8513 17.914 20.0321 18.17C19.2128 18.4259 18.3445 18.4834 17.4986 18.3379C16.6528 18.1924 15.8536 17.848 15.167 17.333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsole);
export default __webpack_public_path__ + "static/media/console.20d636161dc60893849ca19a4e65c59e.svg";
export { ForwardRef as ReactComponent };